import React, { useEffect, useRef, useState } from "react";
import { devLog } from "../../../utils/devLog";
import api, { fetchCheckoutDetails } from "../../../api/api";
import { useCheckout } from "../../../context/CheckoutContext";
import { formatFrequencyUnit } from "../../../utils/commonUtils";
import PaymentProcessingModal from "../../modal/PaymentProcessingModal";
import { set } from "react-hook-form";
import TransactionStatusModal from "../../modal/TransactionStatusModal";
import { toast } from "react-toastify";
import { useStyles } from "../../../context/StyleContext";
import { useIframeResize } from "../../../hooks/useIframeResize";
// import "./PaysafePaymentForm.css"; // Optional if you want to move styles here

const AltruonPaysafePaymentForm = ({
    formData,
    itemDetails,
    billingPlatformId,
    routingEntries,
    planId,
    platformItemDetails,
    checkoutPageConfDto: checkoutPageConfDtoProp,
}) => {
    const queryParams = new URLSearchParams(window.location.search);
    const sessionId = queryParams.get("sessionId");
    const secretKey = queryParams.get("secretKey");
    const siteName = queryParams.get("siteName");
    const scriptRef = useRef(null);
    const instanceRef = useRef(null);
    const [formValid, setFormValid] = useState(true);
    const [loading, setLoading] = useState(false);
    const [paymentResponse, setPaymentResponse] = useState(null);
    const { triggerPaymentMethodEvent, resetTrigger, clientIp, clientCountry, paymentMethodName, platformName, estimatedOrder } = useCheckout();
    const [gatewayConnection, setGatewayConnection] = useState("");
    const [showProcessingModal, setProcessingModal] = useState(false);
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [transactionStatus, setTransactionStatus] = useState("");
    const [checkoutPageConfDto, setCheckoutPageConfDto] = useState(
        checkoutPageConfDtoProp || null
    );
    const { styles } = useStyles();

    useIframeResize({ enabled: true, padding: 40 });

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data.type === "makePayment") {
                handlePayNow();
            }
        };
        window.addEventListener("message", handleMessage);
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);

    useEffect(() => {
        if (triggerPaymentMethodEvent) {
            if (platformName == "paysafe" && paymentMethodName == "card") {
                handlePayNow();
                devLog("Paysafe payment method triggered");
                resetTrigger();
            }
        }
    }, [triggerPaymentMethodEvent]);

    const fetchDetails = async (id, planId) => {
        try {
            const data = await fetchCheckoutDetails(id, planId);
            if (data?.checkoutPageConfDto) {
                setCheckoutPageConfDto(data.checkoutPageConfDto);
            }
        } catch (error) {
            toast.error("Something went wrong. Please try again later.");
        }
    };

    useEffect(() => {
        if (checkoutPageConfDtoProp) {
            setCheckoutPageConfDto(checkoutPageConfDtoProp);
            return;
        }
        if (billingPlatformId && planId) {
            fetchDetails(billingPlatformId, planId);
        }
    }, [billingPlatformId, planId, checkoutPageConfDtoProp]);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://hosted.paysafe.com/js/v1/latest/paysafe.min.js";
        script.async = true;

        //log all form data used

        script.onload = () => {
            const API_KEY = "T1QtMTExNjM4MDpCLXFhMi0wLTY3ZDZkODFkLTAtMzAyZDAyMTQ3YmNjMWUyNGVhZDI0NTRkNDE0Y2FmODJkNGQxMzk3NmIyZmU1ZGRiMDIxNTAwOGNiNzE1NjZhMDZmMjZlMDBkZTI2YzAyZGIwN2VjZGVkOTlhNzAzMw==";

            const options = {
                currencyCode: "USD",
                environment: "TEST",
                fields: {
                    cardNumber: {
                        selector: "#cardNumber",
                        placeholder: "Card Number",
                    },
                    expiryDate: {
                        selector: "#expiryDate",
                        placeholder: "MM/YY",
                    },
                    cvv: {
                        selector: "#cvv",
                        placeholder: "CVV",
                        optional: false,
                    },
                },
            };

            window.paysafe.fields
                .setup(API_KEY, options)
                .then((instance) => {
                    instanceRef.current = instance;
                    return instance.show();
                })
                .catch((error) => {
                    alert("Paysafe setup failed: " + JSON.stringify(error));
                });
        };

        scriptRef.current = script;
        document.body.appendChild(script);

        return () => {
            if (scriptRef.current) {
                document.body.removeChild(scriptRef.current);
            }
        };
    }, []);

    const filterRoutingEntries = (entries, paymentMethod, platform) => {
        return entries.filter(
            (entry) =>
                entry.paymentMethod === paymentMethod && entry.platform === platform
        );
    };


    const handlePayNow = async () => {
        setProcessingModal(true);
        if (!instanceRef.current) return;

        setLoading(true);
        setFormValid(true);

        const tokenizationOptions = {
            amount: itemDetails?.price ? parseFloat(itemDetails.price) * 100 : 1000,
            currencyCode: itemDetails?.currencyCode || "USD",
            transactionType: "PAYMENT",
            paymentType: "CARD",
            merchantRefNum: "ref-" + new Date().getTime(),
            customerDetails: {
                holderName: `${formData?.firstName || "caroline"} ${formData?.lastName || "channing"}`.trim(),
            },
            billingDetails: {
                firstName: formData?.firstName || "caroline",
                lastName: formData?.lastName || "channing",
                country: formData?.billingAddress?.country || clientCountry || "US",
                zip: formData?.billingAddress?.zipCode || "90210",
                street: formData?.billingAddress?.street || "",
                street2: formData?.billingAddress?.addressLine2 || "",
                city: formData?.billingAddress?.city || "",
                state: formData?.billingAddress?.state || "",
            },
            threeDS: {
                profile: {
                    email: formData?.email || "channing@gmail.com",
                    phone: formData?.phone || "023456789",
                    firstName: formData?.firstName || "caroline",
                    lastName: formData?.lastName || "channing",
                },
                useThreeDSecureVersion2: true,
                // authenticationPurpose: "PAYMENT_TRANSACTION",
                merchantUrl: "https://www.altruon.io/",
                deviceChannel: "BROWSER",
            },
        };

        try {
            const routingEntry = filterRoutingEntries(
                routingEntries,
                "card",
                "paysafe"
            );

            if (routingEntry.length === 0) {
                // setError("UPI payment method is not available for this transaction.");
                return;
            }

            // devLog("The filter routing entry ", routingEntry[0]);
            const gateway_connection = await fetchGatewayConnection(routingEntry[0]);
            // devLog("The gatewayCconnection ", gatewayConnection);

            // devLog("The tokenization options are ", tokenizationOptions);
            const result = await instanceRef.current.tokenize(tokenizationOptions);

            const data = {
                siteName: siteName,
                paymentData: {
                    gatewayConnectionId: "4604fe5a-02d6-4589-b769-3ffde92998ac",
                    gatewayName: "paysafe",
                    paymentMethod: "card",
                    amount: 2400,
                    currency: estimatedOrder?.currency || itemDetails?.currencyCode || "USD",
                    transactionId: "",
                    additionalData: {
                        paymentHandleToken: result?.token
                    }
                },
                customerData: {
                    firstName: "caroline",
                    lastName: "channing",
                    email: "test@gmail.com",
                    ip: clientIp || "192.0.126.111",
                    billingAddress: {
                        country: formData?.billingAddress?.country || clientCountry || "US",
                        zipCode: formData?.billingAddress?.zipCode || "90210",
                        street: formData?.billingAddress?.street || "",
                        city: formData?.billingAddress?.city || "",
                        state: formData?.billingAddress?.state || "",
                        number: "1234",
                    },
                    shippingAddress: {},
                },
                billingData: {
                    planId: planId,
                    billingPlatformId: billingPlatformId,
                    billingPlatformName: itemDetails?.billingPlatformName,
                    frequency: formatFrequencyUnit(itemDetails?.period),
                }
            };

            // const data = {
            //     paymentData: {
            //         gatewayConnectionId: gateway_connection?.id,
            //         gatewayName: gateway_connection?.platform,
            //         paymentMethod: "card",
            //         amount: estimatedOrder?.futureInvoiceAmountDue ?
            //             Math.round(estimatedOrder.futureInvoiceAmountDue * 100) :
            //             (itemDetails?.price ? parseFloat(itemDetails.price) * 100 : 1000),
            //         currency: estimatedOrder?.currency || itemDetails?.currencyCode || "USD",
            //         transactionId: "",
            //         additionalData: {
            //             paymentHandleToken: result?.token
            //         }
            //     },
            //     customerData: {
            //         firstName: formData?.firstName,
            //         lastName: formData?.lastName,
            //         email: formData?.email,
            //         ip: clientIp || "192.0.126.111",
            //         billingAddress: {
            //             country: formData?.billingAddress?.country || "US",
            //             zipCode: formData?.billingAddress?.zipCode || "90210",
            //             street: formData?.billingAddress?.street || "",
            //             city: formData?.billingAddress?.city || "",
            //             state: formData?.billingAddress?.state || "",
            //         },
            //         shippingAddress: {
            //         }
            //     },
            //     billingData: {
            //         planId: planId,
            //         billingPlatformId: billingPlatformId,
            //         billingPlatformName: itemDetails?.billingPlatformName,
            //         frequency: formatFrequencyUnit(itemDetails?.period),
            //     }
            // };


            const response = await processTransaction(data);
            setTransactionStatus("success"); // or "failed" based on response
            setShowStatusModal(true);
            // alert("✅ Thank you for subscribing!");
            // window.location.reload();
        } catch (error) {
            console.error("Tokenization or Payment failed:", error);
            alert("❌ Invalid card or payment error: " + JSON.stringify(error));
            setFormValid(false);
        } finally {
            setLoading(false);
        }
    };

    const processTransaction = async (data) => {
        try {
            // devLog("The billing transaciton  ", billingPlatformId);
            const headers = {
                'x-secret-key': secretKey,
            };

            const response = await api.post(`/api/checkout/v1/${billingPlatformId}/processPayment/${sessionId}`, data, {headers: headers});
            if (response.status === 200) {
                // alert(itemDetails?.billingPlatformName + ' Subscription created created successfully!');
                //TODO close the processing modal show Transaction status modal
                return response?.data;
            } else {
                alert("Something went wrong while creating " + itemDetails?.billingPlatformName + " Subscription .");
            }
            setProcessingModal(false);
        } catch (error) {
            console.error("Customer Error:", error);
            alert(`${itemDetails?.billingPlatformName} subscription failed: ${error.response?.data?.message || error.message}`);
        } finally {
            setLoading(false);
            setProcessingModal(false);
        }
    }

    const fetchGatewayConnection = async (routing) => {
        try {
            const response = await api.get(`/api/checkout/v1/${routing?.id}/gatewayConnection`);
            if (response.status === 200) {
                // devLog("Gateway connection fetched successfully:", response);
                setGatewayConnection(response.data);
                return response?.data;
            } else {
                throw new Error("Failed to fetch gateway connection");
            }

        } catch (error) {
            console.error("Error fetching gateway connection:", error);
        }

    }

    return (
        <div className="payment-container">

            <label className="input-label">Card Number</label>
            <div id="cardNumber" className="input-field" />

            <label className="input-label">Expiry Date</label>
            <div id="expiryDate" className="input-field" />

            <label className="input-label">CVV</label>
            <div id="cvv" className="input-field" />

            {/* {!formValid && <div className="error-message">Please enter valid card details.</div>} */}
            {loading && (
                <div className="loader-overlay">
                    <div className="spinner" />
                </div>
            )}


            {/* <button onClick={handlePayNow} disabled={loading} className="pay-now-button">
        {loading ? "Processing..." : "Pay Now"}
      </button> */}

            <style>{`
                .payment-container {
                position: relative;
                width: 100%;
                padding: ${styles.spacing.padding.drawer};
                border-radius: ${styles.borderRadius?.large || '12px'};
                background-color: transparent;
                box-shadow: none;
                font-family: ${styles.typography.fontFamily};
                }

                .input-label {
                font-size: ${styles.components.label.fontSize};
                font-weight: ${styles.components.label.fontWeight};
                margin-top: ${styles.spacing.gap.formElements};
                margin-bottom: ${styles.components.label.marginBottom};
                display: block;
                color: ${styles.components.label.color};
                letter-spacing: ${styles.components.label.letterSpacing};
                font-family: ${styles.typography.fontFamily};
                }

                .input-field {
                border: ${styles.components.input.borderWidth} solid ${styles.components.input.borderColor};
                border-radius: ${styles.borderRadius?.small || styles.components.input.borderRadius || '6px'};
                padding: ${styles.components.input.padding};
                background-color: ${styles.components.input.backgroundColor};
                height: 48px;
                transition: ${styles.transitions?.default || '0.2s ease'};
                }

                .input-field:hover {
                border-color: ${styles.components.input.borderColorHover};
                }
                
                .input-field:focus {
                border-color: ${styles.colors.borderFocus || styles.colors.primary || styles.components.input.borderColorFocus};
                box-shadow: ${styles.components.input.focusShadow};
                }

                .pay-now-button {
                margin-top: ${styles.spacing.margin.sectionBottom};
                padding: ${styles.components.button.primary.padding};
                font-size: ${styles.components.button.primary.fontSize};
                font-weight: ${styles.components.button.primary.fontWeight};
                border: none;
                border-radius: ${styles.borderRadius?.medium || styles.components.button.primary.borderRadius || '8px'};
                background-color: ${styles.components.button.primary.backgroundColor};
                color: ${styles.components.button.primary.textColor};
                cursor: pointer;
                font-family: ${styles.typography.fontFamily};
                transition: ${styles.components.button.primary.transition || styles.transitions?.slow || '0.3s ease'};
                }

                .pay-now-button:hover {
                background-color: ${styles.components.button.primary.backgroundColorHover};
                }

                .pay-now-button:disabled {
                background-color: ${styles.components.button.primary.backgroundColorDisabled};
                }

                .error-message {
                margin-top: ${styles.components.errorMessage.marginTop};
                color: ${styles.components.errorMessage.color};
                font-size: ${styles.components.errorMessage.fontSize};
                font-weight: ${styles.components.errorMessage.fontWeight};
                font-family: ${styles.typography.fontFamily};
                }
                .loader-overlay {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(255, 255, 255, 0.7);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 999;
                }

                .spinner {
                    border: ${styles.components.loader.borderWidth} solid ${styles.components.loader.borderColor};
                    border-top: ${styles.components.loader.borderWidth} solid ${styles.components.loader.borderTopColor};
                    border-radius: ${styles.borderRadius?.round || '50%'};
                    width: ${styles.components.loader.size};
                    height: ${styles.components.loader.size};
                    animation: spin ${styles.components.loader.animationDuration} linear infinite;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

            `}</style>
            <PaymentProcessingModal
                show={showProcessingModal}
                setShow={setProcessingModal}
            />

            <TransactionStatusModal
                show={showStatusModal}
                setShow={setShowStatusModal}
                status={transactionStatus}
                redirectUrl={checkoutPageConfDto?.checkoutRedirectUrl}
            />
        </div>
    );
};

export default AltruonPaysafePaymentForm;


// // Send a single request with all the data
// const response = await createCombinedRequest(requestData);
